import React from "react";
import { TimeDiff } from "../time/TimeDiff";

const TimeContext = React.createContext(new TimeDiff(0, 0));
export default TimeContext;
